import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ReactComponent as TrashOutlined } from '../../images/common/trash_outlined.svg';

const Button = styled.button`
  width: ${props => props.size};
  height: ${props => props.size};
  padding: 0;
  border: none;
  background-color: inherit;
  borderradius: 50%;
  transition: background-color 0.3s;
  opacity: ${props => props.disabled && 0.5};
  cursor: ${props => (props.disabled && 'default') || 'pointer'};
`;

const StyleTrashOutlined = styled(TrashOutlined)`
  fill: ${props => (props.disabled ? '#E4E4E4' : '#004386')};
  vertical-align: middle;
`;

/**
 * 削除ボタンのUIコンポーネント
 *
 * ボタンをクリックすると、親コンポーネントによって提供されたコールバック関数が呼び出される
 *
 * @prop {function} onClick - ボタンがクリックされたときに実行されるコールバック関数
 *
 * @example
 * <TrashCanButton onClick={handleClick} size={size} />
 *
 * @returns {ReactElement}
 */
const TrashCanButton = ({ size, disabled, onClick }) => (
  <Button
    disabled={disabled}
    onClick={disabled ? undefined : onClick}
    className={!disabled && 'button'}
    size={size}
  >
    <StyleTrashOutlined disabled={disabled} />
  </Button>
);

TrashCanButton.propTypes = {
  size: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};
TrashCanButton.defaultProps = {
  size: '40px',
  disabled: false,
};

export default TrashCanButton;
